import o from "./_baseIsSet.js";
import r from "./_baseUnary.js";
import t from "./_nodeUtil.js";
var e = t && t.isSet, s = e ? r(e) : o;
const S = s;
export {
  S as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/isSet.js
// module id = 1566
// module chunks = 67